import { useDetailViewContext } from 'features/views/DetailView/hooks/useDetailViewContext'

export function useDetailViewAttributeValue<T>(fieldApiName: string): T | undefined {
    const { recordManager } = useDetailViewContext()!

    return recordManager?.record?.[fieldApiName] ?? undefined
}
